import { AxiosError } from 'axios';
import instance from '../config/axios';

export const fetchTrainingTools = async (token: string) => {
  try {
    const result = await instance({
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: '/api/v1/training-tools/doctors',
    });

    return result.data;
  } catch (e) {
    return (e as AxiosError).response!.status;
  }
};
